import React, {useEffect, useState} from "react";
import {Button, Form, Input, Modal, notification, Spin, Table, Tag, Tooltip} from "antd";
import {EditOutlined, FilterOutlined} from "@ant-design/icons";
import SharedService from "../../../services/shared/service";
import {useAuth} from "oidc-react";
import SEO from "../../../components/SEO"

const MappedKvps = () => {
    const {userData} = useAuth();
    const [form] = Form.useForm();

    const token = userData?.access_token;
    const [mappedData, setMappedData] = useState([]);
    const [loading, setloading] = useState(false);
    const [inputValues, setInputValues] = useState({});
    const [inputSearchValues, setInputSearchValues] = useState({});
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [searchModalVisible, setSearchEditModalVisible] = useState(false);
    const [listPagination, setlistPagination] = useState({
        totalItemCount: 0,
        pageSize: 10,
        pageNumber: 1,
    });
    const [sortedInfo, setSortedInfo] = useState({});

    const pageSEOSettings = {
        title: "MappedKVP List",
    };

    useEffect(() => {
        fetchMappedkvps();
    }, []);
    useEffect(() => {
        fetchMappedkvps();
    }, [inputSearchValues]);

    useEffect(() => {
        if (listPagination.totalItemCount !== 0) {
            fetchMappedkvps();
        }
    }, [listPagination.pageNumber, sortedInfo]);
    const handleTableChange = (pagination, filters, sorter) => {
        setSortedInfo(sorter);

        setlistPagination({...listPagination, pageNumber: pagination.current});
    };
    const paginationProps = {
        showSizeChanger: false,
        total: listPagination.totalItemCount,
        pageSize: listPagination.pageSize,
        current: listPagination.pageNumber,
    };
    const handleTagClose = (key) => {
        setInputSearchValues((prevValues) => {
            const updatedValues = {...prevValues};
            delete updatedValues[key];
            return updatedValues;
        });
    };
    const fetchMappedkvps = async (values) => {
        setloading(true);

        try {
            let data = {};
            if (values && values !== undefined) {
                data = values;
            } else {
                data = inputSearchValues;
            }

            const params = {
                pageNumber: listPagination.pageNumber,
                pageSize: listPagination.pageSize,
                orderBy: sortedInfo.order
                    ? `${sortedInfo.columnKey}:${sortedInfo.order === "ascend" ? "Asc" : "Desc"
                    }`
                    : "id:Desc", // Concatenate columnKey and order as the orderBy value
            };

            const response = await SharedService.post({
                token,
                url: "mappedkvps/search",
                data,
                params,
            });

            // Handle the response data

            setMappedData(response.items);
            setlistPagination({
                ...listPagination,
                totalItemCount: response.totalItemCount,
            });
            setloading(false);
        } catch (error) {
            if (error.response && error.response.status === 500) {
                notification.error({
                    message: "Error",
                    description: error.response.statusText,
                });
            }
            if (error.response && error.response.status === 502) {
                notification.error({
                    message: "Error",
                    description: error.response.statusText,
                });
            }

            setloading(false);
        }
    };

    const showEditModal = (record) => {
        form.setFieldsValue({
            id: record.id,
            referenceKey: record.referenceKey,
            referenceValue: record.referenceValue,
            inputKey: record.inputKey,
            inputValue: record.inputValue,
            outputKey: record.outputKey,
            outputValue: record.outputValue,
        });

        setEditModalVisible(true);
    };
    const handleCancel = () => {
        setEditModalVisible(false);
    };

    const columns = [
        {
            title: "#",
            dataIndex: "id",
            render: (id) => {
                return (
                    <Tooltip title={id}>
                        <div>{id}</div>
                    </Tooltip>
                );
            },

            key: "id",
            sorter: true,
            sortOrder: sortedInfo.columnKey === "id" && sortedInfo.order,
        },
        {
            title: "Reference Key",
            dataIndex: "referenceKey",
            render: (referenceKey) => {
                return (
                    <Tooltip title={referenceKey}>
                        <div>{referenceKey}</div>
                    </Tooltip>
                );
            },

            key: "referenceKey",
            sorter: true,
            sortOrder: sortedInfo.columnKey === "referenceKey" && sortedInfo.order,
        },
        {
            title: "Reference Value",
            dataIndex: "referenceValue",
            key: "referenceValue",
            render: (referenceValue) => (
                <Tooltip title={referenceValue}>
                    <div>{referenceValue}</div>
                </Tooltip>
            ),

            sorter: true,
            sortOrder: sortedInfo.columnKey === "referenceValue" && sortedInfo.order,
            defaultSortOrder: "Desc",
        },

        {
            title: "Input Key",
            dataIndex: "inputKey",
            key: "inputKey",
            render: (inputKey) => (
                <Tooltip title={inputKey}>
                    <span>{inputKey}</span>
                </Tooltip>
            ),
            sorter: true,
            sortOrder: sortedInfo.columnKey === "inputKey" && sortedInfo.order,
        },
        {
            title: "Input Value",
            dataIndex: "inputValue",
            key: "inputValue",

            render: (inputValue) => (
                <Tooltip title={inputValue}>
                    <span>{inputValue}</span>
                </Tooltip>
            ),

            // onFilter: (value, record) => record.name.includes(value),
            sorter: true,
            sortOrder: sortedInfo.columnKey === "inputValue" && sortedInfo.order,
        },
        {
            title: "Output Key",
            dataIndex: "outputKey",
            key: "outputKey",
            render: (outputKey) => (
                <Tooltip title={outputKey}>
                    <span>{outputKey}</span>
                </Tooltip>
            ),
            sorter: true,
            sortOrder: sortedInfo.columnKey === "outputKey" && sortedInfo.order,
        },
        {
            title: "Output Value",
            dataIndex: "outputValue",
            key: "outputValue",
            render: (outputValue) => (
                <Tooltip title={outputValue}>
                    <span>{outputValue}</span>
                </Tooltip>
            ),
            sorter: true,
            sortOrder: sortedInfo.columnKey === "outputValue" && sortedInfo.order,
        },
        {
            title: "Actions",
            key: "actions",
            render: (text, record) => (
                <Tooltip title="Edit">
                    <EditOutlined
                        style={{fontSize: 20}}
                        onClick={() => showEditModal(record)}
                        className="cursor-pointer"
                    />
                </Tooltip>
            ),
        },
    ];
    const handleEdit = () => {
        // Add your edit logic here using selectedRecord
        form.validateFields().then((values) => {
            form.resetFields();
            setInputValues((prevValues) => ({
                ...prevValues,
                ...values,
            }));
            setEditModalVisible(false);
            updateMappedKvps(values);
        });
    };
    const handleSearch = () => {
        form.validateFields().then((values) => {

            form.resetFields();
            setInputSearchValues((prevValues) => ({
                ...prevValues,
                ...values,
            }));
            setSearchEditModalVisible(false);
            listPagination.pageNumber = 1;
            fetchMappedkvps(values);
        });
    };
    const updateMappedKvps = async (values) => {
        setloading(true);
        try {
            let data = {};
            if (values && values !== undefined) {
                data = values;
            }

            const response = await SharedService.patch({
                token,
                url: "mappedkvp",
                data,
            });
            if (response) {
                notification.success({
                    message: "Updated Successfully",
                });
                fetchMappedkvps();
                setloading(false);
            }

            // Handle the response data as per your requirement
            // Close the popup after the API call is completed
        } catch (error) {
            if (error.response && error.response.status === 500) {
                notification.error({
                    message: "Error",
                    description: error.response.statusText,
                });
            }
            if (error.response && error.response.status === 502) {
                notification.error({
                    message: "Error",
                    description: error.response.statusText,
                });
            }
            // Handle any errors
            setloading(false);
        }
    };
    const handleInputChange = () => {
        form.setFieldsValue({
            id: inputSearchValues.id,
            referenceKey: inputSearchValues.referenceKey,
            referenceValue: inputSearchValues.referenceValue,
            inputKey: inputSearchValues.inputKey,
            inputValue: inputSearchValues.inputValue,
            outputKey: inputSearchValues.outputKey,
            outputValue: inputSearchValues.outputValue,
        });
        setSearchEditModalVisible(true);
    };
    const handleSearchCancel = () => {
        setInputSearchValues({});
        setSearchEditModalVisible(false);
    };
    return (
        <div>
            <SEO {...pageSEOSettings} />
            <div className="px-4 sm:px-7 py-5">
                <div className="text-[22px] font-semibold text-[#0B1220] leading-tight">Mapped key-value pairs</div>
                <div className="text-[13px] text-[#7A849A] mt-1">
                    Translate extracted invoice values to your internal references.
                </div>
            </div>

            <div className="px-4 sm:px-7 pb-7 relative">
                {loading && (
                    <div className="absolute inset-0 flex justify-center items-center bg-white bg-opacity-50 z-10 rounded-[14px]">
                        <Spin size="large" className="custom-spin"/>
                    </div>
                )}

                <div className="flex items-center gap-3 flex-wrap mb-4">
                    {Object.entries(inputSearchValues)
                        .filter(([, value]) => value !== undefined && value !== null && value !== "")
                        .map(([label, value]) => (
                            <Tag
                                key={label}
                                closable
                                onClose={() => handleTagClose(label)}
                                className="!m-0 inline-flex items-center gap-1 px-2.5 py-1 rounded-full"
                                style={{backgroundColor: "#ECF9EE", color: "#1B7A31", border: "1px solid #C8E9CD"}}
                            >
                                <span className="font-semibold">{label}:</span> {value}
                            </Tag>
                        ))}
                    <div className="flex-1"/>
                    <Button icon={<FilterOutlined/>} onClick={handleInputChange}>Filters</Button>
                </div>

                <Table
                    dataSource={mappedData}
                    columns={columns}
                    pagination={paginationProps}
                    onChange={handleTableChange}
                />
            </div>
            <Modal
                title="Update mapping"
                open={editModalVisible}
                onOk={handleEdit}
                onCancel={handleCancel}
                okText="Update"
                cancelText="Cancel"
            >
                {/* Your edit form content here */}
                <Form form={form} layout="vertical" initialValues={inputValues}>
                    <Form.Item name="id" label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">ID</span>}>
                        <Input readOnly disabled={true} placeholder="Enter the Id "/>
                    </Form.Item>
                    <Form.Item
                        name="referenceKey"
                        label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Reference Key</span>}
                    >
                        <Input placeholder="Enter the Reference Key"/>
                    </Form.Item>
                    <Form.Item
                        name="referenceValue"
                        label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Reference Value</span>}
                    >
                        <Input placeholder="Enter the Reference Value"/>
                    </Form.Item>
                    <Form.Item
                        name="inputKey"
                        label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Input Key</span>}
                    >
                        <Input placeholder="Enter the Input Key"/>
                    </Form.Item>
                    <Form.Item
                        name="inputValue"
                        label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Input Value</span>}
                    >
                        <Input placeholder="Enter the Input Value"/>
                    </Form.Item>
                    <Form.Item
                        name="outputKey"
                        label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Output Key</span>}
                    >
                        <Input placeholder="Enter the Output Key"/>
                    </Form.Item>
                    <Form.Item
                        name="outputValue"
                        label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Output Value</span>}
                    >
                        <Input placeholder="Enter the Output Value"/>
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                title="Advanced Search"
                open={searchModalVisible}
                onOk={handleSearch}
                onCancel={handleSearchCancel}
                okText="Search"
                cancelText="Cancel"
                width={560}
            >
                {/* Your edit form content here */}
                <Form form={form} layout="vertical">
                    <Form.Item name="id" label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">ID</span>}>
                        <Input value={inputSearchValues.id} placeholder="Enter the Id "/>
                    </Form.Item>
                    <Form.Item
                        name="referenceKey"
                        label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Reference Key</span>}
                    >
                        <Input placeholder="Enter the Reference Key"/>
                    </Form.Item>
                    <Form.Item
                        name="referenceValue"
                        label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Reference Value</span>}
                    >
                        <Input placeholder="Enter the Reference Value"/>
                    </Form.Item>
                    <Form.Item
                        name="inputKey"
                        label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Input Key</span>}
                    >
                        <Input placeholder="Enter the Input Key"/>
                    </Form.Item>
                    <Form.Item
                        name="inputValue"
                        label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Input Value</span>}
                    >
                        <Input placeholder="Enter the Input Value"/>
                    </Form.Item>
                    <Form.Item
                        name="outputKey"
                        label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Output Key</span>}
                    >
                        <Input placeholder="Enter the Output Key"/>
                    </Form.Item>
                    <Form.Item
                        name="outputValue"
                        label={<span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">Output Value</span>}
                    >
                        <Input placeholder="Enter the Output Value"/>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default MappedKvps;
